import React from "react"
import Container from "../container"
import { Box } from "rebass"

const RowWrapper = props => {
  const { children, spacerX, spacerY, rowID, customMobilePaddingBottom = false } = props

  const mobileSpacerX = spacerX > 0 ? "20px" : 0
  const mobileSpacerY = spacerY > 0 ? Math.max(4, Math.ceil(spacerY / 1.5)) : 0
  const tabletSpacerX = spacerX > 5 ? "60px" : spacerX
  const tabletLandscapeSpacerX = spacerX > 5 ? "90px" : spacerX
  const desktopSpacerX = spacerX ? spacerX : 0
  const desktopSpacerY = spacerY ? spacerY : 0

  return (
    <Container {...props}>
      <Box
        id={rowID}
        px={[mobileSpacerX, null, tabletSpacerX, tabletLandscapeSpacerX, desktopSpacerX]}
        py={[customMobilePaddingBottom ? customMobilePaddingBottom : mobileSpacerY, null, desktopSpacerY]}
      >
        {children}
      </Box>
    </Container>
  )
}

export default RowWrapper
